import {
  BrandAndMarketListItem,
  CodeAndLabel,
  DateTimeRestrictionData,
  FormDataRouteRestriction,
  GuidIdAndLabel,
  GuidIdCodeAndLabel,
  TravelDateRange
} from '../../../../integrated-client/models'

export interface IBCMSSREditorData {
  id?: string | null;
  deleted?: boolean;
  description?: string | null;
  comment?: string | null;
  ctce?: string | null;
  ctcm?: string | null;
  brandAndMarket?: BrandAndMarketListItem;
  suppliers?: Array<GuidIdAndLabel> | null;
  carriers?: Array<GuidIdCodeAndLabel> | null;
  routes?: Array<FormDataRouteRestriction> | null;
  bookingDateTimeRestrictions?: Array<DateTimeRestrictionData> | null;
  bookingDateTimeRestrictionsTimeZone?: CodeAndLabel;
  travelDates?: Array<TravelDateRange> | null;
  excludeCarriers?: boolean;
  disabled?: boolean;
}

export interface IEditorData {
  bcmSsrEditorData: IBCMSSREditorData,
  validation?: any
}

export class BCMSSREditorData implements IBCMSSREditorData {
  id?: string | null;
  deleted?: boolean;
  description?: string | null;
  comment?: string | null;
  ctce?: string | null;
  ctcm?: string | null;
  brandAndMarket?: BrandAndMarketListItem;
  suppliers?: Array<GuidIdAndLabel> | null;
  carriers?: Array<GuidIdCodeAndLabel> | null;
  routes?: Array<FormDataRouteRestriction> | null;
  bookingDateTimeRestrictions?: Array<DateTimeRestrictionData> | null;
  bookingDateTimeRestrictionsTimeZone?: CodeAndLabel;
  travelDates?: Array<TravelDateRange> | null;
  excludeCarriers?: boolean;
  disabled?: boolean;
}

export class EditorData implements IEditorData {

  bcmSsrEditorData: IBCMSSREditorData
  validation?: any

  constructor() {
    this.bcmSsrEditorData = new BCMSSREditorData()
  }
}
